import CloseIcon from '@mui/icons-material/Close'
import { Alert, AlertColor, AlertTitle, IconButton } from '@mui/material'
import classNames from 'classnames'
import { useEffect } from 'react'
import { CSSTransition, TransitionGroup } from 'react-transition-group'

import styles from './ExperimentFormToast.module.css'

export type ToastMessage = {
  id: string
  title: React.ReactNode
  description: React.ReactNode
  type: AlertColor
}

type ExperimentFormToastProps = {
  messages: Array<ToastMessage>
  onMessageExpire: (id: string) => void
  timeout?: number
}

export const ExperimentFormToast = ({ messages, onMessageExpire, timeout = 15000 }: ExperimentFormToastProps) => {
  useEffect(() => {
    messages.forEach(message => {
      const timer = setTimeout(() => {
        onMessageExpire(message.id)
      }, timeout)

      return () => clearTimeout(timer)
    })
  }, [messages, onMessageExpire, timeout])

  return (
    <div style={{ position: 'relative' }}>
      <TransitionGroup className={styles.container}>
        {messages.map(message => {
          return (
            <CSSTransition
              key={message.id}
              timeout={300}
              classNames={{ ...styles }}>
              <Alert
                className={classNames(styles.toast, styles[message.type])}
                severity={message.type}
                icon={<span className={styles.icon} />}
                action={
                  <IconButton
                    aria-label="close"
                    color="inherit"
                    size="small"
                    onClick={() => onMessageExpire(message.id)}>
                    <CloseIcon />
                  </IconButton>
                }>
                <AlertTitle className={styles.title}>{message.title}</AlertTitle>
                {message.description}
              </Alert>
            </CSSTransition>
          )
        })}
      </TransitionGroup>
    </div>
  )
}
